<div class="content-blk ">
	<div class="container">
		<form [formGroup]="storeadminreportingForm" (submit)="fn_getSaleOrderReport(storeadminreportingForm, 'form')">
			<div class="od-sl-cnt">
			<div class="dash-head">
				<h2>
					Order-Sales Report
				</h2>
			</div>
			<div class="rpot-bx">

				<div class="row">
					<div class="col-sm-6 st-spc-rt">
						<div class="row">
							<div class="col-lg-4">
								<label>Select Store</label>
							</div>
							<div class="col-lg-8">
								<mat-form-field >
									<mat-select  placeholder="Store Name" class="order-st-select" (selectionChange)="fn_selectedStore($event.value)" formControlName="StoreId">
										<mat-option *ngIf="storeList?.length > 0" value="" >All</mat-option>
										<mat-option  *ngFor="let item of storeList; let i=index" [value]="item.StoreId" >{{item.StoreName}}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>
					<div class="col-sm-6 st-spc-lt">
						<div class="row">
							<div class="col-lg-4">
								<label>Start Date</label>
							</div>
							<div class="col-lg-8">
								<mat-form-field>
									<input matInput [matDatepicker]="startpicker" placeholder="Choose a date" (dateChange)="FromDateEvent('change', $event)" formControlName="FromDate">
									<mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
									<mat-datepicker #startpicker></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6 st-spc-rt">
						<div class="row">
							<div class="col-lg-4">
								<label>End Date</label>
							</div>
							<div class="col-lg-8">
								<mat-form-field>
									<input matInput [min]="minDate"  [matDatepicker]="endpicker" placeholder="Choose a date" (dateChange)="ToDateEvent('change', $event)" formControlName="ToDate">
									<mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
									<mat-datepicker #endpicker></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
					</div>
					<div class="col-sm-6 st-spc-lt">
						<div class="row">
							<div class="col-lg-4">
								<label>Order Status</label>
							</div>
							<div class="col-lg-8">
								<mat-form-field>
									<mat-select class="order-st-select" (selectionChange)="fn_selectedOrder($event.value)" formControlName="StatusId" >
										<mat-option value="" >All</mat-option>
										<mat-option value="1" >Ordered</mat-option>
											<mat-option value="2" >Confirmed</mat-option>
											<mat-option value="3" >Processing</mat-option>
											<mat-option value="5" >Shipped</mat-option>
											<mat-option value="6" >Delivered</mat-option>
											<mat-option value="4" >Cancel</mat-option>
										</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 text-right od-gt-rpt">
						<a *ngIf="isGenerateExcel" (click)="fn_DownloadSaleOrderReport()" style="cursor: pointer;" class="expt-lnk-pd"> <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 512 512" width="18px"><path d="m512 416v76c0 11.046875-8.953125 20-20 20h-472c-11.046875 0-20-8.953125-20-20v-76c0-11.046875 8.953125-20 20-20s20 8.953125 20 20v56h432v-56c0-11.046875 8.953125-20 20-20s20 8.953125 20 20zm-270.144531 14.140625c7.691406 7.695313 20.417969 7.871094 28.289062 0l113.132813-113.136719c7.8125-7.808594 7.8125-20.472656 0-28.28125-7.808594-7.8125-20.472656-7.8125-28.28125 0l-78.996094 78.992188v-347.714844c0-11.046875-8.953125-20-20-20s-20 8.953125-20 20v347.714844l-78.996094-78.992188c-7.808594-7.8125-20.472656-7.8125-28.28125 0-7.8125 7.808594-7.8125 20.472656 0 28.28125zm0 0" fill="#FFFFFF"/></svg> Export to Excel</a>
						<button mat-raised-button cdkFocusInitial [disabled]="storeadminreportingForm.invalid || storeList?.length === 0" class="mat-btn mat-gnrt-rpt">Generate Report</button>
					</div>
				</div>
					<div class="search-results exprt-exl-pd">
					<div class="sp-admin-list-tbl pro-tble-outer sld-tgl-actn od-sls-lngth" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="100"
					(scrolled)="fn_getSaleOrderReport(storeadminreportingForm, 'scroll')">
						<div class="table-responsive">
						<table class="table" *ngIf="reportList?.length > 0">
							<thead>
							<tr>
								<th class="text-center">Sr. No</th>
								<th>User Name</th>
								<th>Store Name</th>
								<th>Order No</th>
								<th>Order Date</th>
								<th>Status</th>
								<th>Quantity</th>
								<th>Total Price</th>
								<th>Address</th>
								<th>Payment Method</th>
							</tr>
							</thead>
							<tbody>
								<tr *ngFor="let report of reportList; let i=index">
								<td class="text-center">{{i + 1}}</td>
								<td>{{report.UserName}}</td>
								<td>{{report.StoreName}}</td>
								<td>{{report.OrderNumber}}</td>
								<td>{{report.CreatedDate}}</td>
								<td>{{report.StatusName}}</td>
								<td>{{report.Quantity}}</td>
								<td>{{report.TotalPrice}}</td>
								<td>{{report.AddressName}}</td>
								<td>{{report.PaymentMethod}}</td>
								</tr>
							</tbody>
						</table>
						<app-lazy-loader></app-lazy-loader>
						</div>
					</div>
					</div>
			</div>
		</div>
		</form>
	</div>
</div>
